<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <p>Browse our tutorials by topic below</p>

            <div class="row mt-4" v-show="genericTutorials===false">
              <div class="col-4" v-html="tutorialContent">
                  
               </div>
            </div>

            <div class="row mt-4" v-show="genericTutorials===true">
                  <div class="col-4">
                    <h4>Manage Member Accounts</h4>
                    <p>
                      <a href='/tutorials/Adding New Members.pdf' target='_blank'>Adding New Members</a><br />
                      <a href='/tutorials/Adding Existing Members.pdf' target='_blank'>Adding Existing Members</a>
                      <br /><a href='/tutorials/Resend a Verification Email.pdf' target='_blank'>Resend a Verification Email &amp; Pool Invite</a><br />
                      <a href="/tutorials/Changing a Members Email.pdf" target="_blank">Changing a Members Email</a><br />
                      <a href='/tutorials/Resetting a Password.pdf' target='_blank'>Reset a Password</a><br />
                      <a href='/tutorials/Managing Groups.pdf' target='_blank'>Creating and Managing Groups</a><br />
                      <a href='/tutorials/Assigning Groups.pdf' target='_blank'>Assigning Groups</a><br />
                      <a href='/tutorials/Adding Group Filter Tags.pdf' target='_blank'>Adding Group Filter Tags</a><br />
                      <a href='/tutorials/Assigning Privileges.pdf' target='_blank'>Assigning Privileges</a><br />
                      <a href='/tutorials/Messaging Members.pdf' target='_blank'>Messaging Members</a><br />
                      <a href="/tutorials/Archiving Members.pdf" target="_blank">Archiving Members</a><br />
                      <a href="/tutorials/Disabling Members.pdf" target="_blank">Disabling Members</a>
                    </p>
                    <h4 class="mt-4">Viewing Play Data</h4>
                    <p>
                      <a href='/tutorials/Interacting with License Pool Dashboard.pdf' target='_blank'>Interacting with the Dashboard</a><br />
                      <a href='/tutorials/Viewing a Members Activity Timeline.pdf' target='_blank'>Viewing Member Activity Timeline</a><br />
                      <a href='/tutorials/Viewing Transcripts.pdf' target='_blank'>Viewing Transcripts</a><br />
                      <a href='/tutorials/Viewing Past Plays.pdf' target='_blank'>Viewing Past Plays</a><br />
                      <a href="/tutorials/Quick Report - Member Product Completions.pdf" target="_blank">Quick Report - Member Product Completions</a>
                    </p>

                  </div>
                  <div class="col-4">
                    <h4>Viewing Reports and Statistics</h4>
                    <p>
                      <a href='/tutorials/Creating Reports - By Members.pdf' target='_blank'>Creating Reports - By Members</a><br />
                      <a href='/tutorials/Creating Reports - By Product.pdf' target='_blank'>Creating Reports - By Product</a><br />
                      <a href='/tutorials/Creating Reports - By Bundled Product.pdf' target='_blank'>Creating Reports - By Bundled Product</a><br />
                      <a href='/tutorials/Creating Reports - By Group.pdf' target='_blank'>Creating Reports - By Group</a>
                      <br /><a href='/tutorials/Creating Reports - GroupComparison.pdf' target='_blank'>Creating Reports - Group Comparison</a><br />
                      <a href='/tutorials/Creating Reports - Transcript Analytics.pdf' target='_blank'>Creating Reports - Transcript Analytics</a>

                    </p>
                    <h4 class="mt-4">Licenses &amp; Bundles</h4>
                    <p>
                      <a href='/tutorials/Assigning Member Licenses.pdf' target='_blank'>Assigning Member Licenses</a><br />
                      <a href='/tutorials/Assigning Member Bundles.pdf' target='_blank'>Assigning Member Bundles</a><br />
                      <a href='/tutorials/Requesting Product Licenses.pdf' target='_blank'>Requesting Product Licenses</a><br />
                      <a href='/tutorials/Managing Member-Level Bundle Access.pdf' target='_blank'>Managing Member Bundle Access</a><br />
                      <a href='/tutorials/Managing Bundle Availability Schedules.pdf' target='_blank'>Managing Bundle Schedule and Availability</a>

                    </p>
                    <h4 class="mt-4">Accessibility</h4>
                    <p>
                      <a href="/tutorials/Accessibility Features.pdf" target="_blank">Accessibility Features</a>
                    </p>
                  </div>
                  <div class="col-4">

                    <h4>Group Administrator Features</h4>
                    <p>
                      <a href='/tutorials/Adding New Members (Group Admin).pdf' target='_blank'>Adding New Members</a><br />
                      <a href='/tutorials/Creating Reports - By Members (Group Admin).pdf' target='_blank'>Creating Reports - By Members/Subgroups</a><br />
                      <a href='/tutorials/Viewing Transcripts (Group Admin).pdf' target='_blank'>Viewing Transcripts</a><br />
                      <a href='/tutorials/Resend a Verification Email (Group Admin).pdf' target='_blank'>Resend a Verification Email &amp; Pool Invite</a><br />
                      <a href='/tutorials/Resetting a Password (Group Admin).pdf' target='_blank'>Reset a Password</a><br />
                      <a href='/tutorials/Viewing Past Play (Group Admin).pdf' target='_blank'>Viewing Past Play</a><br />
                      <a href="/tutorials/Disabling Members (Group Admin).pdf" target="_blank">Disabling Members</a>
                    </p>
                    <h4 class="mt-4">Troubleshooting Problems</h4>
                    <p>
                      <a href='/tutorials/Advice_Troubleshooting.pdf' target='_blank'>Advice & Troubleshooting</a><br />
                      <a href='/tutorials/Clearing Cache - Various Browsers.pdf' target='_blank'>How to Clear a Browser Cache</a><br />
                      <a href='/tutorials/Contacting Support.pdf' target='_blank'>Contacting Software Support</a>
                    </p>

                  </div>
                </div>

              </div>
            </div>
          </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
    name: 'CliTutorials',
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
          genericTutorials:null,
          tutorialContent:null
      };
    },
    mounted() {
      this.doPage().then(r=>{

        this.bootstrapClient(this.$route.params.id);
 

        this.apiCommand([{
          Operation: "Organization",
          Function: "GetTutorialsByClient",
          Fields: {
            ClientID: this.$route.params.id
          }
        }]).then(r=>{
          var cr=JSON.parse(r.CommandResult);
          var tuts = JSON.parse(cr.returnObjects[0].returnObject);
          if (tuts!==null && tuts.TutorialContent.length>0) {
            this.tutorialContent=tuts.TutorialContent;
            this.genericTutorials=false;
          }
          else {
            this.genericTutorials=true;
          }

        });
      });
    }
  }
</script>
